// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"384d6753","133":"56675f42","182":"36e1ded8"}[chunkId] + ".chunk.js";
};